'use client';

import { c as _c } from "react/compiler-runtime";
import { aspCond } from '@module/helpers/conditions/condition';
import { useFetchGetSitePresetQuery } from '@module/queries/preset/presetQueryHooks';
import useIsMounted from '@module/utils/useIsMounted';
import Link from 'next/link';
function CompanyInfo() {
  const $ = _c(20);
  const isMounted = useIsMounted();
  const {
    data: sitePreset
  } = useFetchGetSitePresetQuery();
  const companyInfo = sitePreset?.company;
  if (!isMounted || !companyInfo) {
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t0 = <></>;
      $[0] = t0;
    } else {
      t0 = $[0];
    }
    return t0;
  }
  let t0;
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = !aspCond.if("asp") && <> I <Link prefetch={false} href="http://www.ftc.go.kr/bizCommPop.do?wrkr_no=8428601445" target="_blank" rel="noreferrer">{"\uC0AC\uC5C5\uC790\uC815\uBCF4\uD655\uC778"}</Link></>;
    t1 = <br />;
    $[1] = t0;
    $[2] = t1;
  } else {
    t0 = $[1];
    t1 = $[2];
  }
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <br />;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== companyInfo.address || $[5] !== companyInfo.business || $[6] !== companyInfo.captain || $[7] !== companyInfo.ceo || $[8] !== companyInfo.email || $[9] !== companyInfo.fax || $[10] !== companyInfo.marketing || $[11] !== companyInfo.nameKr || $[12] !== companyInfo.serviceKr || $[13] !== companyInfo.tel) {
    t3 = <address className="footer-address text-center leading-[24px]">{"\uC11C\uBE44\uC2A4\uBA85"}:{companyInfo.serviceKr} I {"\uD68C\uC0AC\uBA85"}:{companyInfo.nameKr} I {"\uC0AC\uC5C5\uC790\uB4F1\uB85D\uBC88\uD638"}:{companyInfo.business} I {"\uD1B5\uC2E0\uD310\uB9E4\uC5C5 \uC2E0\uACE0\uBC88\uD638"} :{companyInfo.marketing} I {"\uB300\uD45C"}: {companyInfo.ceo}{t0}{t1}{"\uC8FC\uC18C"}: {companyInfo.address}{t2} {"\uAC1C\uC778\uC815\uBCF4 \uAD00\uB9AC \uCC45\uC784\uC790"}:{companyInfo.captain} I {"E-mail"}:{companyInfo.email} I {"\uB300\uD45C\uBC88\uD638"}:{companyInfo.tel} I {"\uD329\uC2A4"}:{companyInfo.fax}{" "}</address>;
    $[4] = companyInfo.address;
    $[5] = companyInfo.business;
    $[6] = companyInfo.captain;
    $[7] = companyInfo.ceo;
    $[8] = companyInfo.email;
    $[9] = companyInfo.fax;
    $[10] = companyInfo.marketing;
    $[11] = companyInfo.nameKr;
    $[12] = companyInfo.serviceKr;
    $[13] = companyInfo.tel;
    $[14] = t3;
  } else {
    t3 = $[14];
  }
  const t4 = `Copyright©${companyInfo.establish} ${companyInfo.nameEn} Corp.All rights reserved. Hosting by 브로드밴드 IDC.`;
  let t5;
  if ($[15] !== t4) {
    t5 = <small className="footer-small block w-full text-center font-bold text-border leading-[24px]">{t4}</small>;
    $[15] = t4;
    $[16] = t5;
  } else {
    t5 = $[16];
  }
  let t6;
  if ($[17] !== t3 || $[18] !== t5) {
    t6 = <>{t3}{t5}</>;
    $[17] = t3;
    $[18] = t5;
    $[19] = t6;
  } else {
    t6 = $[19];
  }
  return t6;
}
export default CompanyInfo;